<div class="carousel">
  <div class="slide-wrapper">
    <img [src]="slides[currentSlide].src" class="slide" />
  </div>

  <div class="controls">
    <button class="control prev" (click)="onPreviousClick()">
      <span class="arrow left"></span>
    </button>
    <button class="control next" (click)="onNextClick()">
      <span class="arrow right"></span>
    </button>
  </div>
</div>
